<template>
  <blog-dashboard-partial
    v-title="`${pageTitle($route)} | Blog`"
    :divisions="divisions"
    :page-title="pageTitle($route) ? ucFirst(pageTitle($route)) : ''"
  />
</template>

<script>
import blogDashboardPartial from './partials/BlogDashboard.vue';

import components from './component-mixin.js';
import data from './data-mixin.js';

import {computed} from 'vue';
import {useHead} from '@vueuse/head';
import {ucFirst, escapeJSON} from '@teemill/utilities';

export default {
  name: 'BlogDashboard',

  components: {
    blogDashboardPartial,
  },

  mixins: [data, components],

  data() {
    return {
      loading: null,
      meta: {
        indexPage: true,
      },
    };
  },

  computed: {
    firstPostImage() {
      if (this.posts.length) {
        return this.posts[0].image.size('banner');
      }

      return null;
    },
  },

  created() {
    useHead(
      computed(() => {
        const host = `${location.protocol}//${location.hostname}`;

        return {
          title: 'Blog',
          script: [
            {
              type: 'application/ld+json',
              children: `
            {

              "@context": "http://schema.org/",
              "@type": "Article",
              "name": "${this.$store.state.subdomain.company.name}",
              "url": "${host}${this.$route.fullPath}",
              "logo": "${this.$store.state.subdomain.company.logo}",
              "image": "${
                this.firstPostImage || this.$store.state.subdomain.company.logo
              }",
              "description": "${
                this.posts.length ? escapeJSON(this.posts[0].title) : ''
              }",
              "brand": {
                "@type": "Brand",
                "name": "${this.$store.state.subdomain.company.name}"
              }
            }
          `,
            },
          ],
          meta: [
            {vmid: 'og:title', property: 'og:title', content: 'Blog'},
            {
              vmid: 'og:description',
              property: 'og:description',
              content: this.posts.length ? this.posts[0].title : '',
            },
            {
              vmid: 'og:image',
              property: 'og:image',
              content:
                this.firstPostImage || this.$store.state.subdomain.company.logo,
            },
            {vmid: 'og:type', property: 'og:type', content: 'article'},

            {vmid: 'twitter:title', property: 'twitter:title', content: 'Blog'},
            {vmid: 'twitter:card', property: 'twitter:card', content: 'photo'},
            {
              vmid: 'twitter:image',
              property: 'twitter:image',
              content:
                this.firstPostImage || this.$store.state.subdomain.company.logo,
            },
          ],
        };
      })
    );
    /**
     * Only set the fetch blogs url next value if there are no blogs in the state
     *
     * So that the pagination is not reset every time the blog dashboard is loaded
     */
    if (!this.$store.state.blog.posts.length) {
      this.$store.commit('blog/setVariable', {
        key: 'next',
        value: '/omnis/v3/blog/paginate/?page=1',
      });
    }
  },

  methods: {
    ucFirst,
  },
};
</script>
